import { Stack } from 'react-bootstrap';
import classNames from 'classnames';

export function ChartPlaceholder(props: {
    heightInPx: number;
    text?: string;
    show?: boolean;
    useLoadingAnimation?: boolean;
}) {
    if (!props.show) return null;

    const yMargin = 15;

    return (
        <Stack
            style={{
                alignItems: 'center',
                background: 'whitesmoke',
                border: '1px solid whitesmoke',
                height: props.heightInPx - 2 * yMargin,
                justifyContent: 'center',
                marginBottom: yMargin,
                marginTop: yMargin,
            }}
        >
            {props.useLoadingAnimation && (
                <div className="loader loader-sm loader-gray">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            )}
            {props.text && (
                <span
                    className={classNames('text-gray', props.useLoadingAnimation && 'mt-2')}
                    style={{ fontSize: '0.9em' }}
                >
                    {props.text}
                </span>
            )}
        </Stack>
    );
}
